<div class="flex flex-col relative w-full font-outfit padding-responsive"
    [class.video-hero]="videoSrc && align !== 'left'" [class.video-hero-left]="videoSrc && align === 'left'"
    [style.paddingTop]="videoSrc ? null : paddingTop" [ngClass]="{'padding-responsive': responsive}">
    <div class="hero-bg absolute inset-0 z-0 overflow-hidden">
        @if (videoSrc) {
        <video #heroVideo class="w-full h-full object-cover" autoplay muted loop playsinline
            [poster]="videoPoster || backgroundImage" aria-hidden="true">
            <source [src]="videoSrc" type="video/mp4" />
        </video>
        } @else {
        <img [src]="backgroundImage" alt="Hero background" class="w-full h-full object-cover" fetchpriority="high"
            decoding="async" />
        }
        <div class="absolute inset-0 pointer-events-none" [ngStyle]="{'background': gradient}"></div>
        @if (align === 'left') {
        <div class="absolute inset-0 pointer-events-none hero-left-scrim"></div>
        }
    </div>

    <div class="hero-content relative z-10 flex flex-col"
        [ngClass]="align === 'left' ? 'mx-auto w-full max-w-site px-6 sm:px-10 items-start text-left' : 'items-center'">
        @if (image) {
        <img class="h-[20px]" [src]="image" alt="">
        }
        @if (text) {
        <span class="h-[20px] font-bold text-base" [class.gradient-text]="align === 'left'">{{ text }}</span>
        }
        @if (title) {
        <img class="px-4 h-[70px] mt-4 pb-[24px] object-contain" [src]="title" alt="">
        }
        @if (titleHtml) {
        <div class="hero-title-text font-outfit font-bold mt-4 pb-[24px]"
            [class.hero-title-text--left]="align === 'left'" [class.px-4]="align !== 'left'"
            [class.text-center]="align !== 'left'" [innerHTML]="titleHtml">
        </div>
        }
        @if (subcopy) {
        <p class="hero-subcopy font-inter text-sm sm:text-base text-text-dim">{{ subcopy }}</p>
        }
        <ng-content select="[hero-cta]"></ng-content>
        @if (projectName) {
        <span class="px-4 h-[70px] mt-4 pb-[24px] font-bold text-4xl gradient-text text-center break-words">
            {{ projectName }}
        </span>
        }
    </div>
</div>
